import { createComparator } from '@tmapy/utils';
export const buildMapSearchConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const mapConfig = tinkerConfig.maps.edges[0]?.node;
    const tabs = tinkerConfig.mapSearches.edges
        .map((mapSearch) => mapSearch.node)
        .filter((mapSearch) => ['GeoCode', 'WFS'].includes(mapSearch.mapService.type))
        .sort(createComparator((asc) => asc.order, (asc) => asc.title, (asc) => asc.id))
        .map((mapSearch) => {
        let contentHtml = `{${mapSearch.value}}`;
        if (mapSearch.label) {
            contentHtml = `<ITEM><LABEL>{${mapSearch.label}}</LABEL><VALUE>{${mapSearch.value}}</VALUE></ITEM>`;
        }
        nonTranslatableResourceStrings[`search.${mapSearch.id}`] = mapSearch.title;
        nonTranslatableResourceStrings[`search.${mapSearch.id}.item.content.html`] = contentHtml;
        nonTranslatableResourceStrings[`search.${mapSearch.id}.input.hint`] =
            mapSearch.hint?.value ?? '';
        return {
            id: mapSearch.id,
            minQueryLength: mapSearch.minQueryLength,
            resultsLimit: mapSearch.resultsLimit,
            type: mapSearch.mapService.type,
            url: mapSearch.mapService.url,
            isAuth: mapSearch.mapService.isAuth,
            fieldName: mapSearch.fieldName,
            outline: mapSearch.outline,
            isFilled: mapSearch.isFilled,
            featureTypes: mapSearch.featureTypes,
        };
    });
    const searchConfig = mapConfig?.enableSearch || tabs.length
        ? { addDefaultTabs: mapConfig?.enableSearch, regionCodes: mapConfig?.regionCodes, tabs }
        : undefined;
    return searchConfig;
};
//# sourceMappingURL=buildMapSearchConfig.js.map